import { SubmitEfficiencyForm } from './submit-efficiency'
import { ShowRemark } from './show-remark'
import { AddProjectForecast } from './add-project-forecast'
import { ShowResourceDetail } from './show-resource-detail'

export {
  SubmitEfficiencyForm,
  ShowRemark,
  AddProjectForecast,
  ShowResourceDetail,
}



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/form/index.js